// extracted by mini-css-extract-plugin
module.exports = {"tableDropDown":"AnnouncementTypesView_tableDropDown_1CD04","info":"AnnouncementTypesView_info_30ffF"};